<template>
  <div class="contentBox">
    <navBox :id="navId" ref="navBox"></navBox>

    <!-- 列表 -->
    <div class="content">
      <myHeader></myHeader>
      <div class="searchBox">
        <div class="search-item">
          <p>用户ID:</p>
          <input type="text" placeholder="" v-model="obj.id	">
        </div>
        <div class="search-item">
          <p>手机号:</p>
          <input type="text" placeholder="" v-model="obj.mobile">
        </div>
        <div class="btnBox">
          <button class="btn btn-search" @click="searchSub">搜索</button>
          <button class="btn btn-reset" @click="resetSub">重置</button>
        </div>
      </div>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>老师管理</p>
          <div class="btnBox">
            <button class="btn btn-updown" @click="updown">下载模板</button>
            <button class="btn btn-updown" @click="importTeacher">导入老师</button>
            
            <button class="btn btn-add" @click="addStudent">添加老师</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList" >
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.id">{{item.id}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.mobile">{{item.mobile}}</p>
              <p :title="item.mock_test_name">{{item.mock_test_name}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p style="color:#FF7543" @click="editSub(item)">编辑</p>
              <p style="color:#FF5156" @click="cancelShow(item)">注销</p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 添加提示框 -->
    <div class="msgBox tipsBox addTips" v-if="addType" >
      <div class="contv">
        <p class="title">{{addType=='add'?'添加老师':'编辑老师'}}</p>
        <form>
          <div class="write-txt">
            <p>老师姓名：</p>
            <input type="text" v-model="addObj.name">
          </div>
          <div class="write-txt">
            <p>手机号：</p>
            <input type="text" v-model="addObj.mobile" @input="numCheck(addObj.mobile,11,'mobile')">
          </div>
          <div class="write-list">
            <div class="write-txt">
              <p>考试：</p>
              <el-select v-model="addObj.mtids" multiple placeholder="请选择" @change="$forceUpdate()">
                <el-option
                  v-for="item in examList"
                  :key="item.mtid"
                  :label="item.name"
                  :value="item.mtid">
                </el-option>
              </el-select>
            </div>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-remove" @click="addSub('add')">添加</button>
          <button class="btn btn-close" @click="closeSub('add')">取消</button>
        </div>
      </div>
    </div>

    <!-- 删除提示框 -->
    <div class="msgBox removeBox" v-if="removeType">
      <div class="contv">
        <p class="title">提示</p>
        <p class="txt">确认注销此条老师数据么？</p>
        <div class="btnBox">
          <button class="btn btn-remove" @click="removeSub('remove')">确认</button>
          <button class="btn btn-close" @click="closeSub('remove')">取消</button>
        </div>
      </div>
    </div>

    <!-- 选择考试 -->
    <div class="msgBox tipsBox examBox" v-if="importType"  v-loading="loading">
      <div class="contv">
        <p class="title">选择考试</p>
        <form>
          <div class="write-txt">
            <p>考试名称：</p>
            <select v-model="mtid">
              <option value="">请选择</option>
              <option :value="item.mtid" v-for="(item,index) in examList" :key="(index+1)">{{item.name}}</option>
            </select>
          </div>
        </form>
        <div class="btnBox">
          <!-- <button class="btn btn-remove" @click="addSub('add')">添加</button> -->
          <el-upload
            v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('2-1')>-1"
            class="upload-demo btn btn-import btn-remove"
            :action="url+'/org/Personnel/importTeacher'"
            :headers="{'userToken':token}"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
            accept=".xls, .xlsx"
            :show-file-list="false"
            :data="{mtid:mtid}"
          >
            <el-button size="small" type="primary">导入老师</el-button>
          </el-upload>
          <button class="btn btn-close" @click="teacherHide('add')">取消</button>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { getTeacherList,getSelectMockTestList,saveTeacher,getTeacherDetail,delTeacher } from "@/assets/js/api";
export default {
  name: "exam",
  data() {
    return {
      fileUrl:'/static/student_template.xlsx',
      navId:'6',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'用户ID'},
        {id:3,title:'老师姓名'},
        {id:4,title:'手机号'},
        {id:5,title:'考试'},
        {id:6,title:'注册时间'},
        {id:7,title:'操作'},
      ],
      dataList:[],
      currentPage1: 2,
      removeType:false,
      topicType:[
        {id:1,title:'单选题'},
        {id:2,title:'多选题'},
        {id:3,title:'判断题'},
      ],
      showType:'list',
      value1: '',
      addType:'',
      addTip:false,
      obj:{
        page:1,
        rows:10,
      },
      addObj:{
        mobile:'',
        name:'',
        mtids:[],
      },
      token:"",
      totalPage:0,
      examList:[],
      certidList:[
        {cert_id:''}
      ],
      removeID:"",
      fileUrl:'/static/teacher_template.xlsx',
      userData:{
        authority:[],
      },
      url:'',
      importType:false,
      mtid:'',
      loading:false
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    var that = this;
    this.userData = this.$refs.navBox.userData
    this.token =this.userData.token;
    this.url = this.$refs.navBox.url;
    getSelectMockTestList(this.token).then((res)=>{
      var data = res.data;
      if(data.code == 200){
        that.examList = data.data;
      } else {
        that.$message(data.msg);
      }
    });
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },


    beforeUpload(){
      this.loading = true;
    },  
    handleSuccess(response, file, fileList){
      var that = this;
      if(response.code == 200){
        that.$message('上传成功！');
        that.loading = false;
        that.teacherHide();
        that.resetSub();
      } else {
        that.$message(response.msg);
      }
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj={
        page:1,
        rows:10,
      };
      this.addObj = {
        mobile:'',
        name:'',
        mtids:[],
      }
      this.dataList = [];
      this.getList();
      
    },

    removeSub(type){
      var that = this;
      if(type == 'tip'){
        this.addTip = false;
      } else if(type == 'add'){
        this.addType = ''
      } else {
        delTeacher({id:that.removeID},that.token).then((res)=>{
          var data = res.data;
          if(data.code == 200){
            that.$message('删除成功！');
            that.resetSub();
            that.removeType = false;
          } else {
            that.$message(data.msg);
          }
        })
      }
    },

    closeSub(type){
      if(type == 'tip'){
        this.addTip = false;
      } else if(type == 'add'){
        this.addObj = {
          mobile:'',
          name:'',
          mtids:[],
        }
        this.addType = ''
      } else {
        this.removeType = false;
      }
    },

    editSub(e){
      var that = this;
      getTeacherDetail({id:e.id},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.addObj = data.data;
          that.addType = 'edit';
          if(that.addObj.mtids.length<=0){
            return false;
          }
          for(var i = 0;i < that.addObj.mtids.length;i++){
            that.addObj.mtids[i] = parseInt(that.addObj.mtids[i])
          };
          that.addObj.id = e.id;
        } else {
          that.$message(data.msg);
        }
      })
    },

    // 添加老师
    addStudent(){
      var that = this;
      this.addType = 'add';
    },

    // 注销
    cancelShow(e){
      this.removeType = true;
      this.removeID = e.id;
    },

    getList(){
      var that = this;
      getTeacherList(this.obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.dataList = data.data.list;
          that.totalPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      })
    },

    addSub(type){
      var that = this;
      if(type == 'add'){
        var regex = /^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9])\d{8}$/i;
        if(that.addObj.name == ''){
          that.$message('请填写姓名！');
          return false;
        } else if(that.addObj.mobile === '' || !regex.test(that.addObj.mobile)){
          that.$message('请输入正确的手机号码！');
          return false;
        };
        if(that.addObj.mtids.length == 0){
          that.$message('请选择证书！');
          return false;
        };
        saveTeacher(that.addObj,this.token).then((res)=>{
          var data = res.data;
          if(data.code == 200){
            that.$message('添加成功！');
            that.resetSub();
            that.addType = '';
          } else {
            that.$message(data.msg);
          }
        })
      }
    },

    numCheck(e,i,type){
      var that = this;
      var num = e;
      num = num.length;
      if(num > i){
          if(type == 'mobile'){
              e = e.slice(0,11);
              that.addObj.mobile = e;
          } else {
              that.code = JSON.stringify(e).slice(0,4)
          }
      }
    },

    updown(){
      var that = this;
      try {
        var elemIF = document.createElement("iframe");
        elemIF.src = that.fileUrl;
        elemIF.style.display = "none";
        document.body.appendChild(elemIF);
      } catch (e) {
          that.$message('下载异常！')
      }
    },

    importTeacher(){
      this.importType = true;
    },

    teacherHide(){
      this.importType = false;
      this.mtid = '';
    }
  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: calc( 100% / 8 );
}

.organiza-list1 .dataList .listItem p,
.organiza-list1 .titleList p{
  width: calc( 100% / 7 );
}

.write-list .btn-add{
  color: #4C7EFB;
  font-size: 15px;
  width: 225px;
  margin-top: 20px;
}

.addStudent.tipsBox .contv{
  height: 80%;
}

.addStudent.tipsBox form{
  height: calc( 100% - 140px );
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 20px;
}

.organiza-title .btnBox .btn{
  display: inline-block;
  vertical-align: top;
  text-align: center;
}
.examBox .el-button--primary{
  background-color: transparent;
  border-color: transparent;
}

.examBox .el-button--small{
  font-size: 14px;
  padding: 0;
}
.examBox .el-upload-list__item-name{
  display: none;
}

.examBox .btnBox .btn{
  width: 200px;
  display: inline-block;
  padding: 10px 0;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/exam/teacher.vue